import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss']
})
export class FilesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
